import { subMatchMenu } from '@/utils/route-menu'
import { settings } from '@/pages/layout/store'
import { useAppStore, useMenuStore } from '@/store'
import { useRoute } from '@/utils'
import { onBeforeUnmount, onMounted } from 'vue'
import lodash from 'lodash'
import router from '@/router'
import { getPermissionInfo } from '@/utils/permission'
/**
 * 保存所属模块信息
 */
function saveModuleInfo(data) {
  const appStore = useAppStore()
  appStore.setModuleInfo(data)
}
/**
 * 监听路由变化，设置导航状态
 * @param route
 */
function setSelect(route) {
  const matchedKeys = route?.meta?.matchedKeys || []
  const headerKey = matchedKeys?.[0]
  const asiedKey = matchedKeys?.[1]
  const name = route?.name
  if (headerKey) {
    settings.defaultHeaderMenuSelect = headerKey
  }
  console.log('log => routerkey', headerKey, asiedKey)
  if (asiedKey && !asiedKey.includes('$$')) {
    settings.defaultSideMenuSelect = asiedKey
  } else if (name) {
    settings.defaultSideMenuSelect = name
  } else if (matchedKeys?.[1]) {
    settings.defaultSideMenuSelect = route?.name
  }
}

/**
 * 权限跳转操作
 * @param path
 */
function permissionHandle(path) {
  const menuStore = useMenuStore()
  // 获取菜单权限列表
  menuStore.getMenuListAll().finally(() => {
    // 无权限
    const permission = getPermissionInfo(path)
    const nodeId = permission?.route?.meta?.nodeId || ''
    if (permission.isNoPermission) {
      router.push({
        name: 'no-permission',
        query: {
          nodeId,
          path,
        },
      })
    }
  })
}
/**
 * 根据路由所属的二级模块
 * @status：优化：菜单信息匹配和无权限信息匹配内部逻辑重复。 subMatchMenu 和 permissionHandle 方法梳理。
 * @param def
 */
export function useMathSubModule(def) {
  const n = def || useRoute()
  const path = n.path
  const isMicroApp = path.includes('gtr_')
  const matchedKeys = n?.meta?.matchedKeys
  let find = null
  console.log('[log]=> meta', path, n?.meta, isMicroApp)
  if (isMicroApp) {
    // 接入微前端的处理逻辑
    try {
      find = subMatchMenu(path, def)
      if (find?.meta?.matchedKeys?.[0]) {
        settings.defaultHeaderMenuSelect = find?.meta?.matchedKeys?.[0]
      }
      if (find?.path) {
        settings.defaultSideMenuSelect = find?.path
      }
    } catch (e) {
      find = n
    }
    if (!lodash.isEmpty(find)) {
      saveModuleInfo({
        keys: find?.meta?.matchedKeys,
        name: find?.meta?.title,
        nodeId: find?.meta?.nodeId,
        key: find?.meta?.key,
      })
    }
    // 权限列表没有的
    if (lodash.isEmpty(find)) {
      permissionHandle(path)
    }
  } else {
    if (matchedKeys?.[0] || n?.name) {
      setSelect(n)
    }
    saveModuleInfo({
      keys: n?.meta?.matchedKeys,
      name: n?.meta?.title,
      nodeId: n?.meta?.nodeId,
      key: n?.meta?.key,
    })
    // 处理基座页面权限
    if (path.includes('/general')) {
      permissionHandle(path)
    }
  }
}

/**
 * 监听判断id='eleId' 是否被引导driver组件选中
 * @status: 因需求交互改变，已无用。可移除
 * @param eleId 目标id
 * @param fn
 */
export function useDriverListener(eleId, fn) {
  const callback = records => {
    // records.forEach((record) => {
    //   console.log(record?.oldValue);
    //   console.log(record?.target.className);
    // });
    const recordsFirst = records[0]
    if (recordsFirst?.target?.className.includes('driver-highlighted-element')) {
      fn('in')
    } else {
      fn('out')
    }
  }
  let mo = null
  onMounted(() => {
    const MutationObserver =
      window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver
    mo = new MutationObserver(callback)
    const element = document.querySelector(eleId)
    const option = {
      childList: false,
      attribute: true,
      attributeOldValue: true,
      attributeFilter: ['class'],
    }
    mo.observe(element, option)
  })
  onBeforeUnmount(() => {
    if (mo) {
      mo.disconnect()
    }
  })
}
